export default "__VITE_ASSET__Dv_LxAbr__"